import React from 'react';
import micIcon from '../assets/home/mic.svg';
import musicIcon from '../assets/home/music.svg';
import sendIcon from '../assets/home/send.svg';
import disableSendIcon from "../assets/home/disabled.svg";
import good from '../assets/home/check.svg';
import bad from '../assets/home/crose.svg';

export default function InputArea({
  newMessage,
  handleChange,
  handleKeyPress,
  listening,
  isTyping,
  toggleMicrophone,
  handleSendMessage,
  stopListening,
  recordingLoading,
  userTyping,
  onDiscardRecording,
}) {
  return (
    <div className="px-3 py-3 sm:p-4 m-2 sm:m-5 mt-0 bg-white border border-gray-200 rounded-xl shadow">
      <div className="flex flex-wrap items-center gap-2 sm:gap-3">
        <div className="flex flex-wrap items-center flex-grow gap-2 sm:gap-3">
          {recordingLoading ? (
           <div className="w-full flex justify-center py-3 sm:py-4">
            <img src={musicIcon} alt="loading" className="h-9 w-auto sm:h-11" />
           </div>
          ) : (
            <textarea
              value={newMessage}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
              className="flex-1 w-full px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base resize-none text-gray-700 border-none outline-none"
              rows={1}
              placeholder={listening ? 'Listening...' : 'Ask me anything about your home...'}
              disabled={isTyping}
            />)}

          {/* Voice Recognition Button */}
          {
            (!userTyping && !recordingLoading) && (
            <button
              onClick={toggleMicrophone}
              className="mx-2 sm:mx-4 rounded-full cursor-pointer shrink-0"
              title={listening ? 'Stop recording' : 'Start voice recording'}
            >
              <img src={micIcon} alt="mic" className="h-9 w-9 sm:h-11 sm:w-11" />
            </button>)
          }

          {/* Loading/Stop Button - Show only when recording */}
          {!recordingLoading && (userTyping ? (
            <button onClick={stopListening} title="Stop recording">
              <img src={disableSendIcon} alt="loading" className="h-9 w-9 sm:h-11 sm:w-11" />
            </button>
          ) : (
            <button
              onClick={handleSendMessage}
              disabled={isTyping || !newMessage.trim()}
              className="flex items-center justify-center cursor-pointer"
            >
              <img src={sendIcon} alt="send" className="h-9 w-9 sm:h-11 sm:w-11" />
            </button>
          ))}

          {
            recordingLoading && (<div className='flex items-center gap-3 sm:gap-4 mr-2 sm:mr-5'>
              <button
                onClick={() => {
                  if (onDiscardRecording) {
                    onDiscardRecording();
                  } else {
                    stopListening();
                  }
                }}
                title="Discard recording"
              >
                <img src={bad} alt="bad" className="h-9 w-9 sm:h-11 sm:w-11" />
              </button>


              <button onClick={stopListening} title="Stop recording">
                <img src={good} alt="good" className="h-9 w-9 sm:h-11 sm:w-11" />
              </button>
            </div>)
          }

        </div>
      </div>
    </div>
  );
}
